module.exports = __webpack_public_path__ + "img/system5.b5f34a16.png";